/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const Microphone01 = ({ className }) => {
  return (
    <svg
      className={`microphone-01 ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M15.8334 8.33332V9.99999C15.8334 13.2217 13.2217 15.8333 10 15.8333M4.16669 8.33332V9.99999C4.16669 13.2217 6.77836 15.8333 10 15.8333M10 15.8333V18.3333M6.66669 18.3333H13.3334M10 12.5C8.61931 12.5 7.50002 11.3807 7.50002 9.99999V4.16666C7.50002 2.78594 8.61931 1.66666 10 1.66666C11.3807 1.66666 12.5 2.78594 12.5 4.16666V9.99999C12.5 11.3807 11.3807 12.5 10 12.5Z"
        stroke="#175CD3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};
